/* eslint-disable prettier/prettier */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from './Components/DynamicComponent';
import 'react-tooltip/dist/react-tooltip.css';
import GtmTracker from './_Addons/PNGtmEnhancedEcom/GtmTracker';

//PandoNexis: BEGIN IMPORT
import MiniCartExtendedContainer from './_Addons/PNMiniCartExtended/Components/MiniCartExtendedContainer';
//PandoNexis: END IMPORT

import './pandoNexis.events.js';
import './pandoNexis.functions.js';

const renderReact = (element, container, callback) => {
    window.__pn.registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

window.__pn = {
    ...window.__pn,
    initNewBuyButton: (button) => {
        initNewBuyButton(button);
    },
    cache: {}, // for storing cache data for current request
};


export const bootstrapPNComponents = () => {


    const initNewBuyButton = (button, buyButtonComponent) => {
        const BuyButton = buyButtonComponent ? buyButtonComponent : DynamicComponent({
            loader: () => import('./_PandoNexis/Components/BuyButton'),
        });

        const {
            articleNumber,
            quantityFieldId,
            href,
            cssClass,
            label,
            gtmTrackingData,
        } = button.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <BuyButton
                    {...{
                        label,
                        articleNumber,
                        quantityFieldId,
                        href,
                        cssClass,
                        gtmTrackingData,
                    }}
                />
            </Provider>,
            button
        );
    };

    const buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length > 0) {
        const BuyButton = DynamicComponent({
            loader: () => import('./_PandoNexis/Components/BuyButton'), // import('./Components/BuyButton'),
        });
        Array.from(buyButtons).forEach(
            (button) => {
                initNewBuyButton(button, BuyButton);
            }
        );
    }

    // Checkout page
    const checkoutEl = document.getElementById('checkout');
    if (checkoutEl) {
        const Checkout = DynamicComponent({
            loader: () => import('./_Addons/pnCheckoutExtended/Components/Checkout'),
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <Checkout />
            </Provider>,
            checkoutEl
        );
    }
    // END Checkout page

    //if (document.getElementById('checkout')) {
    //    const Checkout = DynamicComponent({
    //        loader: () => import('./_PandoNexis/Components/Checkout'),
    //    });
    //    renderReact(
    //        <Provider store={window.__pn.store}>
    //            <Checkout />
    //        </Provider>,
    //        document.getElementById('checkout')
    //    );
    //}

    // PRODUCT PAGE IMAGES
    const lightBoxImagesEl = document.getElementById('lightBoxImages');
    if (lightBoxImagesEl) {
        const LightboxImages = DynamicComponent({
            loader: () => import('./_Solution/Components/LightboxImages'),
        });
        import('./Reducers/LightboxImages.reducer').then(
            ({ lightboxImages }) => {
                window.__pn.store.injectReducer('lightboxImages', lightboxImages);
                const rootElement = lightBoxImagesEl;
                const images = Array.from(
                    rootElement.querySelectorAll('template')
                ).map((img) => ({
                    html: img.innerHTML,
                    src: img.dataset.src,
                }));
                renderReact(
                    <Provider store={window.__pn.store}>
                        <LightboxImages images={images} />
                    </Provider>,
                    lightBoxImagesEl
                );
            }
        );
    }
    // END PRODUCT PAGE IMAGES

    // ICONS
    const iconEls = document.querySelectorAll('.pn-icon');
    if (iconEls) {
        const PnIcon = DynamicComponent({
            loader: () => import('./_PandoNexis/Components/PnIcon'),
        });
        iconEls.forEach((elem) => {
            const { iconName, title, width, height } = elem.dataset;
            ReactDOM.render(
                <Provider store={window.__pn.store}>
                    <PnIcon iconName={iconName} title={title} width={width} height={height} />
                </Provider>,
                elem
            );
        });
    }

    // ADDONS

    //PandoNexis: BEGIN  COMPONENT
    // CollectionPage
    const collectionPage = document.getElementById("collectionPage");
    if (collectionPage) {
        const CollectionPage = DynamicComponent({
            loader: () => import('./_Addons/PNCollectionPage/Components/CollectionPageContainer'),
        });

        const { collectionPageSystemId, link, linkText } = collectionPage.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <CollectionPage {...{ collectionPageSystemId, link, linkText }} />
            </Provider>,
            collectionPage
        );
    }
    // END CollectionPage


    // PNCookieConsent
    const CookieConsentEl = document.getElementById('cookieConsent');
    if (CookieConsentEl) {
        const CookieConsent = DynamicComponent({
            loader: () => import('./_Addons/PNCookieConsent/Components/CookieConsent')
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <CookieConsent {...{ cookiebarVisible: true }} />
            </Provider>,
            CookieConsentEl
        )
    }

    const cookieSettingsButton = document.getElementById('cookieSettingsButton');
    if (cookieSettingsButton) {
        const CookieSettings = DynamicComponent({
            loader: () => import('./_Addons/PNCookieConsent/Components/CookieConsent')
        });
        renderReact(
            <Provider store={window.__pn.store}>
                <CookieSettings {...{ showButton: true }} />
            </Provider>,
            cookieSettingsButton
        )
    }
    // END PNCookieConsent


    // PNHeaderUSPs
    // Fade in-out header-USPs
    const uspsEl = document.querySelector(".pn-header__header-usps");
    if (uspsEl) {
        const paragraps = uspsEl.querySelectorAll("p");
        if (paragraps) {
            const pCount = paragraps.length;
            if (pCount > 0) {
                const activeClass = "active";
                paragraps[0].classList.add(activeClass);

                if (paragraps.length > 1) {
                    let currentIndex = 0;
                    const uspInterval = setInterval(() => {
                        paragraps[currentIndex++].classList.remove(activeClass);
                        if (pCount == currentIndex) {
                            currentIndex = 0;
                        }
                        paragraps[currentIndex].classList.add(activeClass);
                    }, 4500);
                }
            }
        }
    }
    // END PNHeaderUSPs
    // Show Infinite scroll Button
    const infiniteScrollButton = document.getElementById("InfiniteScroll");
    if (infiniteScrollButton) {
        const InfiniteScrollButton = DynamicComponent({
            loader: () => import('./_Addons/PNInfiniteScroll/Components/InfiniteScrollButtonContainer'),
        });
        const { elementQs, totalPages, totalCount, currentPageIndex, pageSize, url, scrollType } = infiniteScrollButton.dataset;
        renderReact(
            <Provider store={window.__pn.store}>
                <InfiniteScrollButton {...{ elementQs, url, scrollType }} totalPages={parseInt(totalPages)} totalCount={parseInt(totalCount)} currentPageIndex={parseInt(currentPageIndex)} pageSize={parseInt(pageSize)} />
            </Provider>,
            infiniteScrollButton
        );
    }
    // END Show Infinite Scroll Button
    // Mini Cart Extended (Off-canvas)

    const miniCartExtended = document.getElementById('PNMiniCartExtended');
    if (miniCartExtended) {
        const { isInCheckout, showInfo } = miniCartExtended.dataset || 'false';

        ReactDOM.render(
            <Provider store={window.__pn.store}>
                <MiniCartExtendedContainer
                    isInCheckout={isInCheckout === 'true'}
                    showInfo={showInfo}
                />
            </Provider>,
            miniCartExtended
        );
    }
    // END Mini Cart Extended (Off-canvas)
    // BEGIN PNEnhancedEcom

    // add new element
    const gtmEnhancedEcomListener = document.createElement('div');
    const GtmEnhancedEcomListener = DynamicComponent({
        loader: () => import('./_Addons/PNGtmEnhancedEcom/GtmEnhancedEcomListener'),
    });
    ReactDOM.render(
        <Provider store={window.__pn.store}>
            <GtmEnhancedEcomListener />
        </Provider>,
        gtmEnhancedEcomListener
    );

    window.gtmTracker = new GtmTracker();
    document.addEventListener('click', (event) => {
        var gtmClickTracking;
        const node = event.target;
        if (node.matches('.gtm-productclick')) {
            gtmClickTracking = node.getAttribute('data-gtmclicktracking');
        }
        const parentNode = event.target.parentNode;
        if (parentNode.matches('.gtm-productclick')) {
            gtmClickTracking = parentNode.getAttribute('data-gtmclicktracking');
        }
        if (gtmClickTracking != null) {
            window.gtmTracker.click(gtmClickTracking);
        }
    }, false);

    window.addEventListener('load',
        () => {
            var prodBlock = document.querySelectorAll('.gtm-productimpression');

            if (prodBlock) {
                const prodBlockLength = prodBlock.length;
                for (var j = 0; j < prodBlockLength; j++) {
                    var impressionTracking = prodBlock[j].getAttribute('data-gtmimpressiontracking');
                    if (impressionTracking.length === 0) continue;
                    window.gtmTracker.impressions(JSON.parse(impressionTracking));
                }
            }
        });
    // END PNEnhancedEcom

    //PandoNexis: END COMPONENT
}
